"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Url = require("url-parse");
exports.GROUPS_BASE_API_URL = '/social-groups/api/';
exports.RICH_CONTENT_API_URL = "/rich-content";
exports.DUPLEXER_API_URL = "/wix-duplexer-sockets-server";
/**
 * Resolve social groups api base path depending on the `wixCodeApi.window.viewMode`
 * i.e. in Editor it would be `https://groups.wixapps.net/social-groups/api/`
 *
 * (see https://www.wix.com/corvid/reference/wix-window.html for more on `wixCodeApi.window`)
 */
function getBaseUrl(wixCodeApi) {
    var hostname = (self.location && self.location.hostname) || '';
    var baseUrl = wixCodeApi.location.baseUrl;
    var locationUrl = baseUrl.includes(hostname)
        ? baseUrl
        : (self.location && self.location.origin) || '';
    return getApiBaseUrl(locationUrl);
}
exports.default = getBaseUrl;
function getApiBaseUrl(locationUrl) {
    var _a = new Url(locationUrl), origin = _a.origin, hostname = _a.hostname;
    var apiUrl;
    switch (hostname) {
        // all requests after page ready in editor "edit" mode
        case "groups.wixapps.net" /* GROUPS */:
        // dashboard
        case "www.wix.com" /* WIX */:
            apiUrl = exports.GROUPS_BASE_API_URL;
            break;
        // all requests before page ready in editor "preview" mode
        case "editor.wix.com" /* EDITOR */:
            apiUrl = '/_api/social-groups-web/';
            break;
        case 'localhost':
        // live site
        default:
            apiUrl = "/_api/social-groups/";
    }
    return "" + origin + apiUrl;
}
exports.getApiBaseUrl = getApiBaseUrl;
function getApiURL(locationUrl, apiUrl) {
    var url = new Url(locationUrl);
    return "" + url.origin + apiUrl;
}
function getSocialApiBaseUrl(locationUrl) {
    var apiUrl = "/social-content/api/v1/";
    //TODO: social api doesn't work in editor preview and some other cases? TEST
    return getApiURL(locationUrl, apiUrl);
}
exports.getSocialApiBaseUrl = getSocialApiBaseUrl;
function getDuplexerApiUrl(locationUrl) {
    var url = new Url(locationUrl);
    var host;
    if (url.host.includes("dev.wix-code.com" /* DEV_WIX_CODE */)) {
        host = "www.wix.com" /* WIX */;
    }
    else {
        host = url.host;
    }
    return "" + host + exports.DUPLEXER_API_URL;
}
exports.getDuplexerApiUrl = getDuplexerApiUrl;
function getRCApiBaseUrl(locationUrl) {
    //TODO: rich-content api doesn't work in editor preview and some other cases? TEST
    return getApiURL(locationUrl, exports.RICH_CONTENT_API_URL);
}
exports.getRCApiBaseUrl = getRCApiBaseUrl;
function getClubsApiUrl(locationUrl) {
    var hostname = new Url(locationUrl).hostname;
    if (hostname === "editor.wix.com" /* EDITOR */) {
        return "//groups.wixapps.net/api/v1/";
    }
    var apiUrl = "/clubs/api/v1";
    return getApiURL(locationUrl, apiUrl);
}
exports.getClubsApiUrl = getClubsApiUrl;
//# sourceMappingURL=baseUrl.js.map